
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-utmb/registration/information",
      function () {
        return require("private-next-pages/my-utmb/registration/information.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-utmb/registration/information"])
      });
    }
  